import { z } from "zod";

import { getNormalEnum } from "../pseudoEnums.js";

/**
 * Lives here rather than in `./types.ts`, and is re-exported from there, purely
 * so the Python kernel type generator can resolve it.
 *
 * That generator flattens every `@hex/common` file it needs into one directory
 * keyed by basename, and `@hex/common` has three `types.ts` files (chart,
 * explore, hql). `hql/types.ts` loses that race, so anything importing a symbol
 * from it resolves to `any` -- and zod's `z.infer` collapses a whole object type
 * when any member is `any`, which silently drops the enclosing type from the
 * generated Python. `display-table/filterTypes.ts` imports this symbol and is
 * reached by the generator, so it takes the unique path.
 *
 * See the note in `packages/server/scripts/shared-kernel-types/utils.ts`.
 */
export const HqlAggregationFunctionLiteral = z.enum([
  "Min",
  "Max",
  "Avg",
  "Count",
  "CountDistinct",
  "Sum",
  "StdDev",
  "StdDevPop",
  "Variance",
  "VariancePop",
  "Median",
]);

export const HqlAggregationFunction = getNormalEnum(
  HqlAggregationFunctionLiteral,
);
export type HqlAggregationFunction = z.infer<
  typeof HqlAggregationFunctionLiteral
>;
